import HeaderTop from './HeaderTop'
import HeaderBottom from './HeaderBottom'

function Header() {
    return (
        <header>
            <HeaderTop />
            <HeaderBottom />
        </header>
    )
}

export default Header;